import { createApp } from 'vue';

import JobsearchFrontpageApp from 'JIX/components/jobsearch/JobsearchFrontpageApp.vue';
import createStore from 'JIX/store/jobsearch.js';


const stash = window.Stash['jobsearch/frontpage_form'];

const store = createStore({ ...stash.storeData });

const app = createApp(JobsearchFrontpageApp, stash.rootProps);
app.use(store);
app.mount(stash.mountSelector);
